import { Controller } from '@hotwired/stimulus';
import { hide, show } from '@frontend/utils/dom';

export default class extends Controller {
  static targets = ['expandButton', 'collapseButton', 'collapsibleSection'];
  static classes = ['collapse'];

  expand() {
    hide(this.expandButtonTarget);
    show(this.collapseButtonTarget);
    this.collapsibleSectionTarget.classList.remove(this.collapseClass);
  }

  collapse() {
    hide(this.collapseButtonTarget);
    show(this.expandButtonTarget);
    this.collapsibleSectionTarget.classList.add(this.collapseClass);
  }
}
